import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { db } from "@/config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";

const QUOTES = [
  { q: "Ich denke, also bin ich – aber heute denk ich lieber nicht zu viel, sonst krieg ich Migräne.", a: "Descartes 1596–1650 & Katzenberger 1986–" },
  { q: "Der Mensch ist frei geboren, und überall liegt er in Ketten – aber guck mal, wie geil die glitzern!", a: "Rousseau 1712–1778 & Schäfer 1983–" },
  { q: "May the Force be with you – außer beim Autofahren, da geht’s nach Gefühl!", a: "Obi-Wan Kenobi 1977 & Basler 1968–" },
  { q: "Gott würfelt nicht – aber der Wendler schon, meistens um Unterhalt.", a: "Einstein 1879–1955 & Wendler 1972–" },
  { q: "I’ll be back – sobald ich mein Proteinshake fertig hab.", a: "Terminator 1984 & Pocher 1978–" },
  { q: "To be or not to be – Hauptsache schön braun!", a: "Shakespeare 1564–1616 & Wollersheim 1951–" },
  { q: "Ich habe einen Traum – und er hat 500 PS.", a: "Martin L. King Jr. 1929–1968 & Matthäus 1961–" },
  { q: "Im Anfang war das Wort – und das war leider ‚Digga‘.", a: "Johannes ca. 100 n. Chr. & Knossi 1986–" },
  { q: "Was mich nicht umbringt, macht mich stärker – und breiter im Kreuz.", a: "Nietzsche 1844–1900 & Lombardi 1992–" },
  { q: "Ich bin der König der Welt! – Halt mal kurz mein Bier.", a: "Titanic 1997 & Barth 1972–" },
  { q: "Cogito ergo sum – und ich schwör, Bruder, ich hab nachgedacht!", a: "Descartes 1596–1650 & Haftbefehl 1985–" },
  { q: "Wer kämpft, kann verlieren, wer nicht kämpft, hat keine Insta-Reichweite.", a: "Brecht 1898–1956 & Thomalla 1989–" },
  { q: "Ich liebe es, wenn ein Plan funktioniert – vor allem, wenn der DJ das Drop setzt.", a: "A‑Team 1983 & Lombardi 1992–" },
  { q: "Ask not what your country can do for you – frag lieber, ob’s WLAN hat.", a: "Kennedy 1917–1963 & Schäfer 1983–" },
  { q: "Houston, wir haben ein Problem – mein Lidschatten sitzt nicht!", a: "Apollo 13 1970 & Katzenberger 1986–" },
  { q: "Ich bin gekommen, um zu dienen – aber das Buffet war halt schon offen.", a: "Jesus 4 v. Chr.–30 n. Chr. & Matthäus 1961–" },
  { q: "Wer zu spät kommt, den bestraft das Leben – oder Dieter Bohlen.", a: "Gorbatschow 1931–2022 & Bohlen 1954–" },
  { q: "Ich habe nichts zu bieten außer Blut, Schweiß und Tränen – und ein paar geile Beats.", a: "Churchill 1874–1965 & Shirin David 1995–" },
  { q: "Die Freiheit des Menschen liegt nicht darin, tun zu können, was er will – sondern ein Cabrio zu fahren.", a: "Kant 1724–1804 & Kahn 1969–" },
  { q: "Hasta la vista, Baby – ich geh kurz Solarium.", a: "Terminator 1984 & Menderes 1984–" },
  { q: "Alle Menschen werden Brüder – bis das Erbe verteilt wird.", a: "Schiller 1759–1805 & Basler 1968–" },
  { q: "Der Klügere gibt nach – und der Dümmere geht ins Fernsehen.", a: "Adenauer 1876–1967 & Fleur 1990–" },
  { q: "Ein kleiner Schritt für einen Menschen, ein großer für mein Insta-Reel.", a: "Armstrong 1930–2012 & Hummels 1988–" },
  { q: "Ich kam, sah und siegte – im Halbfinale von Promi Big Brother.", a: "Caesar 100–44 v. Chr. & Nick 1956–" },
  { q: "Wir sind, was wir wiederholt tun – und wenn du halt immer schlecht singst, biste halt kein Superstar.", a: "Aristoteles 384–322 v. Chr. & Bohlen 1954–" },
  { q: "Alles fließt – sogar mein Selbstbräuner nach dem dritten Aperol.", a: "Heraklit 520–460 v. Chr. & Glööckler 1965–" },
  { q: "Die Tugend liegt in der Mitte – aber da steht bei mir der Champagnerkübel.", a: "Marcus Aurelius 121–180 & Kahn 1969–" },
  { q: "Erkenne dich selbst – aber poste es nicht gleich auf Instagram.", a: "Sokrates 469–399 v. Chr. & Katzenberger 1986–" },
  { q: "Kein Mensch wird zufällig gut – aber viele zufällig berühmt.", a: "Seneca 4 v. Chr.–65 n. Chr. & Pooth 1968–" },
  { q: "Der Charakter offenbart sich in der Krise – oder im Dschungeltelefon.", a: "Aristoteles 384–322 v. Chr. & Matthäus 1961–" },
  { q: "Nichts geschieht ohne Grund – außer mein Album Release 2007.", a: "Thales 624–546 v. Chr. & Bohlen 1954–" },
  { q: "Nur in der Dunkelheit siehst du die Sterne – und die RTL-Scheinwerfer.", a: "Pythagoras 570–510 v. Chr. & Basler 1968–" },
  { q: "Wahrheit wohnt im tiefsten Grund – gleich neben der Minibar.", a: "Platon 428–348 v. Chr. & Verona Pooth 1968–" },
  { q: "Wer sich selbst überwindet, ist stark – wer sich selbst filtert, ist viral.", a: "Seneca 4 v. Chr.–65 n. Chr. & Nick 1956–" },
  { q: "Das Leben ist Veränderung – und mein Gesicht auch.", a: "Heraklit 520–460 v. Chr. & Pooth 1968–" },
  { q: "Man erkennt den Menschen an dem, worüber er lacht – und ich lach, wenn die anderen rausfliegen.", a: "Diogenes 412–323 v. Chr. & Bohlen 1954–" },
  { q: "Der Mensch strebt nach Glück – ich nach Likes.", a: "Aristoteles 384–322 v. Chr. & Nena 1960–" },
  { q: "Philosophie ist Staunen – und Staunen ist das neue Botox.", a: "Sokrates 469–399 v. Chr. & Pooth 1968–" },
  { q: "Die Zeit heilt alle Wunden – aber die PR-Abteilung macht’s schneller.", a: "Marcus Aurelius 121–180 & Lagerfeld 1933–2019" },
  { q: "Alles fließt – besonders mein Selbstbräuner nach dem dritten Hugo.", a: "Heraklit 520–460 v. Chr. & Glööckler 1965–" },
  { q: "Gott würfelt nicht, aber RTL schon – meistens mit mir.", a: "Einstein 1879–1955 & Bohlen 1954–" },
  { q: "Wer schön sein will, muss leiden – wer berühmt sein will, muss posten.", a: "Platon 428–348 v. Chr. & Pooth 1968–" },
  { q: "Ich weiß, dass ich nichts weiß – aber RTL weiß wenigstens, wann Quote ist.", a: "Sokrates 469–399 v. Chr. & Bohlen 1954–" },
  { q: "Nichts dauert ewig – außer meine Peinlichkeit bei ‚Wetten, dass..?‘.", a: "Seneca 4 v. Chr.–65 n. Chr. & Basler 1968–" },
  { q: "Kein Übel ist groß, wenn man darüber lachen kann – oder es streamt.", a: "Seneca 4 v. Chr.–65 n. Chr. & Glööckler 1965–" },
  { q: "Die Natur will nichts vergeblich – aber RTL schon.", a: "Aristoteles 384–322 v. Chr. & Kahn 1969–" },
  { q: "Wenn du über das Leben nachdenkst, mach’s bitte mit Nebelmaschine.", a: "Sokrates 469–399 v. Chr. & Verona Pooth 1968–" },
  { q: "Erfahrung ist der Anfang der Weisheit – und das Ende der Karriere.", a: "Aristoteles 384–322 v. Chr. & Basler 1968–" },
  { q: "Glück hängt nicht vom Besitz ab – aber eine Villa auf Malle schadet nie.", a: "Epikur 341–270 v. Chr. & Kuhlenkamp 1970–" },
  { q: "Das Geheimnis des Glücks ist die Freiheit, das Geheimnis der Freiheit ist der Mut – aber wenn du keinen Mut hast, kommst du auch nicht ins Dschungelcamp.", a: "Thukydides 460–396 v. Chr. & Matthäus 1961–" },
];

export default function Login() {
  const { loginWithIdentifier, user, loading: authLoading } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const prefillUser = params.get("u") || "";
  const prefillPass = params.get("p") || "";
  const nextParam = params.get("next");
  const from = (typeof nextParam === "string" && nextParam.startsWith("/") && !nextParam.startsWith("/login"))
    ? nextParam
    : (typeof location.state?.from === "string" && location.state.from.startsWith("/") && !location.state.from.startsWith("/login")
      ? location.state.from
      : "/");
  const [identifier, setIdentifier] = useState(prefillUser);
  const [password, setPassword] = useState(prefillPass);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!authLoading && user && !loading) nav(from, { replace: true });
  }, [authLoading, user, from, nav, loading]);

  const quote = useMemo(()=>{
    const i = Math.floor(Math.random()*QUOTES.length);
    return QUOTES[i];
  },[]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const creds = await loginWithIdentifier(identifier, password);
      let target = from;
      if (target === "/" && creds?.user?.uid) {
        try {
          const snap = await getDoc(doc(db, "users", creds.user.uid));
          const home = snap.exists() ? snap.data().homeRoute : null;
          if (typeof home === "string" && home.startsWith("/")) target = home;
        } catch (_) {}
      }
      nav(target, { replace: true });
    } catch (e2) {
      setErr("Anmeldung fehlgeschlagen. Bitte überprüfe Anmeldenamen/E-Mail und Passwort.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0e0b0c] flex items-center justify-center px-4 pb-20" data-testid="login-screen">
      <Card className="w-full max-w-sm bg-[#1a0d11] border-white/10 text-rose-50">
        <CardContent className="pt-6">
          <div className="text-[11px] text-rose-200/70 mb-3 italic leading-snug">“{quote.q}”<div className="opacity-70 mt-1">— {quote.a}</div></div>
          <h1 className="text-2xl font-bold mb-6" data-testid="login-title">RhnStrß</h1>
          {err && (
            <div className="text-red-300 text-sm mb-3" data-testid="login-error">{err}</div>
          )}
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-sm">E-Mail oder Anmeldename</label>
              <Input data-testid="login-identifier" type="text" value={identifier} onChange={(e)=>setIdentifier(e.target.value)} required className="bg-[#2a1419] border-white/10 text-rose-50" />
            </div>
            <div>
              <label className="text-sm">Passwort</label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="bg-[#2a1419] border-white/10 text-rose-50" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[#b40023] hover:bg-[#97001d]">{loading?"Anmelden…":"Anmelden"}</Button>
          </form>
          <p className="text-xs mt-4 text-rose-100/70">Kein Konto? <Link data-testid="go-register" className="underline" to="/register">Registrieren</Link></p>
        </CardContent>
      </Card>
    </div>
  );
}
